var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_162_965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4125 1.3479H4.7985C2.20124 1.3479 0.102539 3.44463 0.102539 6.03795V52.964C0.102539 55.5495 2.20124 57.6521 4.7985 57.6521H54.4125C56.9979 57.6521 59.1025 55.5514 59.1025 52.964V6.03795C59.1006 3.44463 56.996 1.3479 54.4125 1.3479ZM39.761 18.0646C38.5412 17.3512 37.5737 16.7876 36.3578 16.7876C35.1675 16.7876 34.1507 17.0852 33.6305 17.5857C33.1102 18.0823 32.8521 19.044 32.8521 20.4648V22.5674H39.2152L37.8377 28.4162H32.8521V47.8503H24.8593V28.4162H21.1289V22.5674H24.8632V20.3347C24.8632 17.9838 25.145 16.5768 25.7007 15.4161C26.2545 14.2593 27.3285 12.9705 28.8222 12.2414C30.3139 11.5143 32.521 11.1477 34.8049 11.1477C37.146 11.1477 38.9748 11.9281 41.2173 12.5567L39.761 18.0646Z",
    fill: "#FE5840"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_162_965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "#FE5840",
    transform: "translate(0.102539)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.52f3daed97fd73de027929d43071eff6.svg";
export { ForwardRef as ReactComponent };